import type { LangStrings } from './en';

export const it: LangStrings = {
  back: 'INDIETRO',
  next: 'AVANTI',
  retry: 'RIPROVA',
  replay: 'RIGIOCA',
  sector: 'SETTORE',
  sectors: 'SETTORI',
  levels: 'LIVELLI',
  cleared: 'COMPLETATO',
  open: 'APERTO',
  locked: 'BLOCCATO',
  tba: 'TBA',
  slot_reserved: 'RISERVATO',
  sfx_on: 'SFX ON',
  sfx_off: 'SFX OFF',
  reset_progress: 'AZZERA PROGRESSI',
  wiped_reloading: 'AZZERATO, RICARICO…',
  got_it: '› CAPITO ‹',

  boot_eyebrow: 'PROTOCOLLO CASCATA  //  BUILD',
  boot_tagline: 'UN TOCCO. UNA CASCATA. NIENTE REPLAY.',
  boot_subtitle: '信号崩壊  ·  LOGICA CASCATA',
  boot_cta: '› TOCCA PER AVVIARE ‹',
  boot_region: 'REGIONE ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // ONLINE',

  menu_header_subtitle: 'NØDUS / SELEZIONE.SETTORE',
  menu_engine_label: 'motore di collasso segnale',
  menu_signals_down: 'segnali abbattuti',
  menu_tap_chapter: 'TOCCA UN CAPITOLO PER ENTRARE',
  menu_language_label: 'LINGUA',

  chapter_signals_down: 'segnali abbattuti',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'CODA',
  chapter_coda_tagline: 'Niente di nuovo. Tutto combinato.',

  hud_tap_to_breach: '▾  tocca un nodo per violare  ▾',
  hud_tap_to_skip: "salta  ▸▸",
  hud_drag_zoom_help: 'trascina per scorrere · rotella/pizzico per zoom',
  hud_required: 'RICHIESTO',
  hud_core_online: 'NUCLEO ATTIVO',
  hud_core_down: 'NUCLEO CADUTO',

  tut_tap_any_node: 'TOCCA QUALSIASI NODO',
  tut_they_all_work: 'qui funzionano tutti',

  brief_eyebrow: '◂ BRIEFING ▸',
  brief_title: 'UN TOCCO.\nUNA CASCATA.',
  brief_line_1: '› Hai esattamente UN tocco.',
  brief_line_2: '› Innesca una reazione a catena nella rete.',
  brief_line_3: '› Fai cadere ogni RICHIESTO (diamante ciano) per vincere.',
  brief_line_4: '› Mai far toccare un impulso a un PROTETTO (rosso).',
  brief_begin: '› AVVIA BRIEFING ‹',

  result_win_headline: 'SISTEMA CROLLATO',
  result_fail_headline: 'CASCATA FALLITA',
  result_first_clear: '› PRIMA VITTORIA ‹',
  result_try_label: '› PROVA',
  result_cleared_suffix: 'COMPLETATO',
  result_aborted_suffix: 'ESECUZIONE ABORTITA',
  result_win_body_template: '{ticks} tick. {nodes} nodi caduti.',

  fail_protected_overload: 'Nodo protetto in sovraccarico. La cascata ha colpito qualcosa che non doveva.',
  fail_forbidden_trigger: 'Una linea proibita ha portato un segnale. Allarme grave attivato.',
  fail_required_not_reached: 'Un nodo richiesto non ha mai ricevuto un impulso. La catena non l\'ha raggiunto.',
  fail_required_under_threshold: 'Un richiesto non ha ricevuto abbastanza impulsi. Il decadimento ha ucciso il primo prima del secondo.',
  fail_core_not_collapsed: 'Il nucleo è sopravvissuto. La cascata si è dissipata prima.',
  fail_core_under_threshold: 'Il nucleo ha ricevuto impulsi ma non abbastanza, non hanno convergito in tempo.',
  fail_core_shielded: 'Impulsi del nucleo bloccati. Uno scudo era ancora attivo.',
  fail_chain_died: 'La catena è morta prima di raggiungere qualcosa.',
  fix_protected_overload: 'Scegli un avviatore la cui cascata non raggiunga mai il pericolo rosso. Traccia prima le uscite.',
  fix_forbidden_trigger: 'Evita avviatori che sparano VERSO un cavo rosso tratteggiato. L\'allarme scatta subito.',
  fix_required_not_reached: 'Il tuo avviatore non si collega a quel nodo. Guarda le frecce, i cavi direzionali vanno solo in una direzione.',
  fix_required_under_threshold: 'Trova una rotta che consegni due impulsi a quel nodo, un divisore o due percorsi convergenti bastano.',
  fix_core_not_collapsed: 'Serve più convergenza verso il nucleo. Divisori, condensatori e relè esistono per alimentarlo.',
  fix_core_under_threshold: 'Gli impulsi arrivano troppo lenti. Usa divisori per accatastare colpi, o falli arrivare nello stesso tick.',
  fix_core_shielded: 'Abbatti ogni scudo prima di qualsiasi colpo finale. Un cavo a ritardo in arrivo tardivo è pulito.',
  fix_chain_died: 'Il tuo avviatore si collega solo a un nodo. Scegline uno al centro della rete.',

  popup_new_node: '◂ NUOVO TIPO DI NODO ▸',
  popup_new_wire: '◂ NUOVO TIPO DI CAVO ▸',

  node_normal_title: 'NODO',
  node_normal_tagline: 'L\'unità base. Tocca per avviare una cascata.',
  node_normal_b1: 'Crolla al primo impulso che arriva.',
  node_normal_b2: 'Spara un impulso su ogni cavo uscente aperto.',
  node_normal_b3: 'Nessuna soglia, un colpo e sparisce.',

  node_required_title: 'RICHIESTO',
  node_required_tagline: 'Devi far crollare ogni RICHIESTO per vincere.',
  node_required_b1: 'Diamante ciano. Pulsa leggero a riposo per essere visibile.',
  node_required_b2: 'Alcuni richiedono 2+ impulsi nella stessa finestra.',
  node_required_b3: 'Sbaglia anche uno e l\'esecuzione finisce.',
  node_required_note: 'Un piccolo anello di punti mostra il suo progresso di carica.',

  node_protected_title: 'PROTETTO',
  node_protected_tagline: 'Toccalo e l\'intera esecuzione muore.',
  node_protected_b1: 'Croce rossa di pericolo. Marcato con angoli.',
  node_protected_b2: 'Qualsiasi impulso = FALLIMENTO istantaneo.',
  node_protected_b3: 'Pianifica una rotta che non lo alimenti mai.',

  node_relay_title: 'RELÈ',
  node_relay_tagline: 'Apre cavi bloccati quando crolla.',
  node_relay_b1: 'Chevron dorato. I suoi bersagli sono cavi BLOCCATI tratteggiati.',
  node_relay_b2: 'Quando il relè cade, i suoi cavi bloccati si aprono.',
  node_relay_b3: 'Utile per rivelare una rotta verso un nodo guardato.',

  node_shield_title: 'SCUDO',
  node_shield_tagline: 'Una guardia del corpo. Assorbe colpi per un altro nodo.',
  node_shield_b1: 'Anello esagonale verde attorno al nodo protetto.',
  node_shield_b2: 'Un impulso diretto su nodo schermato NON FA NULLA.',
  node_shield_b3: 'Fai cadere lo scudo prima, poi consegna il colpo finale.',
  node_shield_note: 'I cavi a RITARDO (oro tratteggiato) sono perfetti per un colpo post-scudo.',

  node_splitter_title: 'DIVISORE',
  node_splitter_tagline: 'Moltiplica impulsi su tutte le uscite.',
  node_splitter_b1: 'Forcella magenta. Un impulso entra → N impulsi per uscita.',
  node_splitter_b2: 'Il marcatore X mostra il suo fattore di divisione.',
  node_splitter_b3: 'Fornisce i colpi multipli che serve un NUCLEO ad alta soglia.',

  node_capacitor_title: 'CONDENSATORE',
  node_capacitor_tagline: 'Memorizza un impulso, poi lo riemette, un buffer.',
  node_capacitor_b1: 'Simbolo giallo di condensatore. Inoltra un impulso 3 tick dopo.',
  node_capacitor_b2: 'Trattalo come un RITARDO integrato nella rotta.',
  node_capacitor_b3: 'Permette a un impulso successivo di arrivare DOPO la caduta di uno scudo.',

  node_core_title: 'NUCLEO',
  node_core_tagline: 'L\'obiettivo. Soglia alta, decadimento veloce.',
  node_core_b1: 'Reattore viola. Richiede molti impulsi convergenti per cadere.',
  node_core_b2: 'La carica DECADE, gli impulsi devono arrivare ravvicinati.',
  node_core_b3: 'Spesso protetto da scudi. Falli cadere, poi inonda il nucleo.',
  node_core_note: 'Un livello con NUCLEO si vince facendolo crollare. I richiesti (se ci sono) contano comunque.',

  wire_directional_title: 'CAVO DIREZIONALE',
  wire_directional_tagline: 'Conduttore a senso unico. Ciano con freccia.',
  wire_directional_b1: 'L\'impulso viaggia solo nella direzione della freccia.',
  wire_directional_b2: 'Tocca dal lato sbagliato della freccia e nulla scorre.',
  wire_directional_b3: 'Segui le frecce dal tuo avviatore fino in fondo.',

  wire_delay_title: 'CAVO A RITARDO',
  wire_delay_tagline: 'Oro tratteggiato. L\'impulso arriva 3 tick dopo.',
  wire_delay_b1: 'Utile per il timing, fai arrivare un impulso DOPO la caduta di uno scudo.',
  wire_delay_b2: 'O per accumulare due impulsi su un nodo ad alta soglia.',
  wire_delay_b3: 'Sbaglia il timing e il primo impulso decade prima.',

  wire_locked_title: 'CAVO BLOCCATO',
  wire_locked_tagline: 'Grigio tratteggiato + lucchetto. Chiuso finché qualcosa lo apre.',
  wire_locked_b1: 'Un RELÈ controlla ogni cavo bloccato.',
  wire_locked_b2: 'Quando il relè crolla, i suoi cavi bloccati scattano aperti.',
  wire_locked_b3: 'Non sprecare un tocco cercando di alimentarne uno direttamente.',

  wire_forbidden_title: 'CAVO PROIBITO',
  wire_forbidden_tagline: 'ROSSO tratteggiato con croce. Toccarlo = fallimento istantaneo.',
  wire_forbidden_b1: 'Qualsiasi impulso, anche di transito, attiva l\'allarme.',
  wire_forbidden_b2: 'Tienili d\'occhio sulle uscite di ogni avviatore.',
  wire_forbidden_b3: 'Scegli un avviatore la cui rotta non tocchi MAI il rosso.',

  wire_burn_title: 'CAVO INCENDIARIO',
  wire_burn_tagline: 'Ottone arancione. Conduttore monouso, brucia dopo un impulso.',
  wire_burn_b1: 'Porta esattamente UN impulso, poi muore per sempre.',
  wire_burn_b2: 'Pianifica il suo uso unico con cura, niente seconda chance.',
  wire_burn_b3: 'Una volta bruciato, nessuna cascata può attraversarlo.',

  callout_required_crashed: 'RICHIESTO CADUTO',
  callout_core_breached: 'NUCLEO PERFORATO',
  callout_shield_dropped: 'SCUDO CADUTO',
  callout_relay_opened: 'RELÈ APERTO',
  callout_protected_hit: 'PROTETTO COLPITO',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Il tuo tocco',
  result_map_broke: 'Fallito qui',
  result_map_answer: 'Funziona',
  result_show_answer: 'Mostra la soluzione',
  menu_endless_line: 'Livelli generati con tre vite. Più scendi, più morde.',
  menu_best: 'Migliore LV {n}',
  menu_best_streak: 'Migliore LV {n}  ·  serie ×{s}',
  menu_resume: 'Riprendi LV {n}',
  menu_start: 'Inizia LV 1',
  result_run_total: 'Totale della corsa {n}',
  result_streak: 'Serie ×{n}',
  result_streak_wins: '{n} vittorie di fila',
  legend_title: 'Legenda',
  legend_nodes: 'NODI',
  legend_wires: 'FILI',
  legend_close: 'Tocca ovunque per chiudere',
  settings_sync_now: 'Sincronizza ({who})',
  settings_sign_in: 'Accedi per sincronizzare',
  settings_sign_out: 'Esci',

};
